import React from 'react';
import PropTypes from 'prop-types';
import Translation from '../../../translation/translation';

/**
 *
 * @param metroArea
 * @param staticImagesUrl
 * @param postcode
 * @param freeShipping
 */
function FreeShipping({metroArea, staticImagesUrl, postcode, freeShipping}) {
    if ('' === postcode && true === freeShipping) {
        return (
            <p className="product-tile__free-shipping-metro-area">
                <img
                    src={`${staticImagesUrl}images/svg/delivery-truck-with-tyres.svg`}
                    width="24"
                />
                <Translation translationKey="product-tile-notification-free-shipping-text" placeholder={{metroArea}}/>
            </p>
        );
    } else {
        return null;
    }
}

FreeShipping.propTypes = {
    metroArea: PropTypes.string.isRequired,
    postcode: PropTypes.string,
};

FreeShipping.defaultProps = {
    postcode: '',
};

export default FreeShipping;
